"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityWarningInteractiveIcon = exports.DataQualityWarningNonInteractiveButton = exports.DataQualityWarningInteractiveButton = exports.DataQualityCertificationNonInteractiveIcon = exports.DataQualityCertificationInteractiveButtonOrIcon = void 0;
const tslib_1 = require("tslib");
/* eslint-disable deprecation/deprecation */
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const DataQualityStyles_1 = require("../style/DataQualityStyles");
const DataQualityIndicatorSharedHelpers_1 = require("./DataQualityIndicatorSharedHelpers");
function DataQualityCertificationButtonContent(props) {
    const { state } = props;
    return (react_1.default.createElement("div", { style: {
            backgroundColor: (state === null || state === void 0 ? void 0 : state.active) || (state === null || state === void 0 ? void 0 : state.hover) || (state === null || state === void 0 ? void 0 : state.selected) || false ? '#E5EDE4' : '#EDF5EC',
            color: '#666666',
            borderRadius: '12.5px',
            height: '25px',
            width: '100px',
        } },
        react_1.default.createElement("span", { style: { position: 'relative', top: '5px', fontWeight: 'bold', fontSize: '12px' } },
            react_1.default.createElement(catalog_icons_1.SvgCertifiedIconDefault, null)),
        react_1.default.createElement("span", { style: { position: 'relative', top: '3px', marginLeft: '4px', fontWeight: 'bold', fontSize: '12px' } }, catalog_messages_1.Messages.DataQualityTypeCertified())));
}
function DataQualityCertificationIconContent(props) {
    const { state } = props;
    return (react_1.default.createElement("span", null, (state === null || state === void 0 ? void 0 : state.active) || (state === null || state === void 0 ? void 0 : state.hover) || (state === null || state === void 0 ? void 0 : state.selected) || false
        ? react_1.default.createElement(catalog_icons_1.SvgCertifiedIconActive, null)
        : react_1.default.createElement(catalog_icons_1.SvgCertifiedIconDefault, null)));
}
/**
 * @deprecated TFS-1478812
 */
exports.DataQualityCertificationInteractiveButtonOrIcon = react_1.default.forwardRef(function DataQualityCertificationInteractiveButton(props, ref) {
    const style = props.iconOnly
        ? {
            height: '14px',
            width: '14px',
        }
        : {
            borderRadius: '12.5px',
            height: '25px',
            width: '100px',
        };
    return (react_1.default.createElement(widgets_1.ButtonWidget, { testId: props.testId, tabIndex: props.tabIndex, onClick: props.onClick, buttonRef: ref, style: style, title: '', buttonType: widgets_1.ButtonType.IconOutline, getContent: state => props.iconOnly
            ? react_1.default.createElement(DataQualityCertificationIconContent, { state: state })
            : react_1.default.createElement(DataQualityCertificationButtonContent, { state: state }) }));
});
/**
 * @deprecated TFS-1478812
 */
function DataQualityCertificationNonInteractiveIcon() {
    return react_1.default.createElement(catalog_icons_1.SvgCertifiedIconDefault, null);
}
exports.DataQualityCertificationNonInteractiveIcon = DataQualityCertificationNonInteractiveIcon;
/**
 * @deprecated TFS-1478812
 */
exports.DataQualityWarningInteractiveButton = react_1.default.forwardRef(function DataQualityWarningInteractiveButton(props, ref) {
    const type = props.warningKind === 'severe-warning' ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info;
    return (react_1.default.createElement(widgets_1.CompactInlineAlertWidget, { testId: props.testId, type: type, onClick: props.onClick, ref: ref, tabIndex: props.tabIndex }, props.title));
});
/**
 * @deprecated TFS-1478812
 */
function DataQualityWarningNonInteractiveButton(props) {
    const type = props.warningKind === 'severe-warning' ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info;
    return (react_1.default.createElement(widgets_1.CompactInlineAlertWidget, { testId: props.testId, type: type }, props.title));
}
exports.DataQualityWarningNonInteractiveButton = DataQualityWarningNonInteractiveButton;
/**
 * @deprecated TFS-1478812
 */
exports.DataQualityWarningInteractiveIcon = react_1.default.forwardRef(function DataQualityWarningInteractiveIcon(props, ref) {
    const isSevere = props.warningKind === 'severe-warning';
    return (react_1.default.createElement(widgets_1.ButtonWidget, { testId: props.testId, buttonRef: ref, tabIndex: props.tabIndex, onClick: props.onClick, title: props.title, buttonType: widgets_1.ButtonType.IconOutline, getContent: s => react_1.default.createElement(DataQualityIndicatorSharedHelpers_1.DataStatusIcon, { isSevere: isSevere, hover: s.hover || false }), style: DataQualityStyles_1.DataQualityStatusIconButtonStyle }));
});
//# sourceMappingURL=DataQualityIndicatorButtons.js.map